import {
    GATEWAYHISTORY_SUCCESS,
    GATEWAYHISTORY_FAILED,
    RESET_GATEWAYHISTORY,
    LOADING_GATEWAYHISTORY,
    NETWORK_ERROR_GATEWAYHISTORY
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGatewayHistory = () => {
    return { type: RESET_GATEWAYHISTORY };
};

const gatewayHistory = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GATEWAYHISTORY });
    await partnerServices
        .post("getHistoryGatewayAccount", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(gatewayHistorysuccess(res.data));
                    break;
                default:
                    dispatch(gatewayHistoryFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GATEWAYHISTORY,
                payload: err
            });
        });
};
function gatewayHistorysuccess(data) {
    return {
        type: GATEWAYHISTORY_SUCCESS,
        payload: data
    };
}
function gatewayHistoryFailed(data) {
    return {
        type: GATEWAYHISTORY_FAILED,
        payload: data
    };
}

export { resetGatewayHistory, gatewayHistory };
